module.exports = __webpack_public_path__ + "img/head.bd8e1aaf.png";